const DASHBOARD_BASE_URL = "/dashboard";
const DASHBOARD_ROUTES = Object.freeze({
    Overview: `${DASHBOARD_BASE_URL}/overview`,
    Analytics: `${DASHBOARD_BASE_URL}/analytics`,
});

const LABSTORE_BASE_URL = "/labstore";
const LABSTORE_ROUTES = Object.freeze({
    Store: `${LABSTORE_BASE_URL}/store`,
    Product: `${LABSTORE_BASE_URL}/store/product/:id`,
    PublishedProducts: {
        List: `${LABSTORE_BASE_URL}/published-products`,
        Create: `${LABSTORE_BASE_URL}/published-products/create`,
        ProductReview: `${LABSTORE_BASE_URL}/published-products/product/review`,
        Comments: `${LABSTORE_BASE_URL}/published-products/comments`,
    },
    PublishedProductVersion: {
        List: `${LABSTORE_BASE_URL}/published-products/:id`,
        Create: `${LABSTORE_BASE_URL}/published-products/product/version/create`,
        Update: `${LABSTORE_BASE_URL}/published-products/product/version/update/:productVersionId`,
    },
    PublishBundle: `${LABSTORE_BASE_URL}/publish-bundle`,
    SubscribedProducts: `${LABSTORE_BASE_URL}/subscribed-products`,
    Coupons: `${LABSTORE_BASE_URL}/coupons`,
    PromoCodes: `${LABSTORE_BASE_URL}/coupons/promotion-codes`,
});

const MODEL_DEVELOPMENT_BASE_URL = "/model-development";
const MODEL_DEVELOPMENT_ROUTES = Object.freeze({
    Measurements: `${MODEL_DEVELOPMENT_BASE_URL}/measurements`,
    MeasurementsConversionConfiguration: `${MODEL_DEVELOPMENT_BASE_URL}/measurements/conversion-configuration`,
    Models: {
        List: `${MODEL_DEVELOPMENT_BASE_URL}/models`,
        Create: `${MODEL_DEVELOPMENT_BASE_URL}/models/create`,
        CreateCustom: `${MODEL_DEVELOPMENT_BASE_URL}/models/create/custom`,
        CreateLinked: `${MODEL_DEVELOPMENT_BASE_URL}/models/create/linked`,
        Upload: `${MODEL_DEVELOPMENT_BASE_URL}/models/upload`,
        Clone: `${MODEL_DEVELOPMENT_BASE_URL}/models/clone`,
        Edit: `${MODEL_DEVELOPMENT_BASE_URL}/models/edit`,
    },
    ModelParameter: {
        Get: `${MODEL_DEVELOPMENT_BASE_URL}/models/parameter`,
        Create: `${MODEL_DEVELOPMENT_BASE_URL}/models/parameter/create`,
    },
});

const SCANS_MANAGEMENT_BASE_URL = "/scans-management";
const SCANS_MANAGEMENT_ROUTES = Object.freeze({
    Scans: {
        List: `${SCANS_MANAGEMENT_BASE_URL}/scans`,
        Get: `${SCANS_MANAGEMENT_BASE_URL}/scans/details`,
        Filters: `${SCANS_MANAGEMENT_BASE_URL}/scans/filters`,
    },
    Alerts: {
        List: `${SCANS_MANAGEMENT_BASE_URL}/alerts`,
        Create: `${SCANS_MANAGEMENT_BASE_URL}/alerts/create`,
        Edit: `${SCANS_MANAGEMENT_BASE_URL}/alerts/edit`,
    },
});

const ACCESS_MANAGEMENT_BASE_URL = "/access-management";
const ACCESS_MANAGEMENT_ROUTES = Object.freeze({
    Affiliates: {
        List: `${ACCESS_MANAGEMENT_BASE_URL}/affiliates`,
        Form: `${ACCESS_MANAGEMENT_BASE_URL}/affiliates/form`,
    },
    Users: {
        List: `${ACCESS_MANAGEMENT_BASE_URL}/users`,
        Form: `${ACCESS_MANAGEMENT_BASE_URL}/users/form`,
    },
    AffiliateProfile: `${ACCESS_MANAGEMENT_BASE_URL}/affiliates/affiliate-profile`,
});

const MATERIALS_BASE_URL = "/materials";
const MATERIALS_ROUTES = Object.freeze({
    MaterialGroups: `${MATERIALS_BASE_URL}/material-groups`,
    Lots: `${MATERIALS_BASE_URL}/lots`,
    MaterialsSuppliers: `${MATERIALS_BASE_URL}/materials-suppliers`,
});

const OPTIONS_BASE_URL = "/options";
const OPTIONS_ROUTES = Object.freeze({
    ModelTransfer: `${OPTIONS_BASE_URL}/model-transfer`,
    UnitsManagement: `${OPTIONS_BASE_URL}/units-management`,
    ClassifiersManagement: `${OPTIONS_BASE_URL}/classifiers-management`,
    DeviceManagement: `${OPTIONS_BASE_URL}/device-management`,
    Notifications: {
        List: `${OPTIONS_BASE_URL}/notifications`,
        Create: `${OPTIONS_BASE_URL}/notifications/create`,
    },
    ApiKeys: `${OPTIONS_BASE_URL}/api-keys`,
    ActivityFeed: `${OPTIONS_BASE_URL}/activity-feed`,
});

const LABLAKE_BASE_URL = "/lablake";
const LABLAKE_ROUTES = Object.freeze({
    Dashboard: {
        Analytics: `${LABLAKE_BASE_URL}/analytics`,
    },
    Instruments: {
        List: `${LABLAKE_BASE_URL}/instruments`,
        Create: `${LABLAKE_BASE_URL}/instruments/create`,
        Update: `${LABLAKE_BASE_URL}/instruments/update/:instrumentId`,
    },
    Materials: {
        List: `${LABLAKE_BASE_URL}/materials`,
        Create: `${LABLAKE_BASE_URL}/materials/create`,
    },
    MaterialVersions: {
        List: `${LABLAKE_BASE_URL}/materials/:materialId/versions`,
        Create: `${LABLAKE_BASE_URL}/materials/:materialId/versions/create`,
        Update: `${LABLAKE_BASE_URL}/materials/:materialId/versions/update/:versionId`,
    },
    Scans: {
        List: `${LABLAKE_BASE_URL}/scans`,
        Get: `${LABLAKE_BASE_URL}/scans/details`,
    },
    Alerts: {
        List: `${LABLAKE_BASE_URL}/alerts`,
        Create: `${LABLAKE_BASE_URL}/alerts/create`,
        Edit: `${LABLAKE_BASE_URL}/alerts/edit`,
    },
    LabLakeFileUploads: `${LABLAKE_BASE_URL}/uploads`,
});

const USER_MENU_ROUTES = Object.freeze({
    Security: "/security",
    Profile: "/profile",
    SubscriptionHistory: "/subscription-history",
});

const PAYMENTS_ROUTES = Object.freeze({
    Payments: "/payments",
    PaymentConfirmation: "payments/confirm/:sessionId",
});

const GLOBAL_ROUTES = Object.freeze({
    Support: "/support",
    PageNotFound: "/page-not-found",
    PartnerProfile: "/partners/profile/:name",
    LicenseExpired: "/license-expired",
});

const AUTH_ROUTES = Object.freeze({
    Login: "auth/login",
    LoginCallback: "login/callback",
    CustomLoginCallback: "login/custom-callback",
});

const EXTERNAL_ROUTES = Object.freeze({
    Feedmill: {
        Shipments: `${process.env.REACT_APP_FEEDMILL_URL}/shipments`,
        Batches: `${process.env.REACT_APP_FEEDMILL_URL}/batches`,
    },
});

export {
    DASHBOARD_ROUTES,
    LABSTORE_ROUTES,
    MODEL_DEVELOPMENT_ROUTES,
    SCANS_MANAGEMENT_ROUTES,
    ACCESS_MANAGEMENT_ROUTES,
    MATERIALS_ROUTES,
    OPTIONS_ROUTES,
    LABLAKE_ROUTES,
    USER_MENU_ROUTES,
    PAYMENTS_ROUTES,
    GLOBAL_ROUTES,
    AUTH_ROUTES,
    EXTERNAL_ROUTES,
};
